import { render } from "./ListWidget.vue?vue&type=template&id=060efca8&scoped=true"
import script from "./ListWidget.vue?vue&type=script&lang=js"
export * from "./ListWidget.vue?vue&type=script&lang=js"

import "./ListWidget.vue?vue&type=style&index=0&id=060efca8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060efca8"]])

export default __exports__